import { isPlatformBrowser } from '@angular/common';
import { inject, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';

@Pipe({
  name: 'decodeHtml',
  standalone: true
})
export class DecodeHtmlPipe implements PipeTransform {
  private platformId = inject(PLATFORM_ID);

  transform(value: string): string {
    if (!value) return '';
    
    // use DOMParser only in browser environment, 
    // not on server, because SSR approache is used
    if (isPlatformBrowser(this.platformId)) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(value, 'text/html');
      return doc.documentElement.textContent || '';
    }

    return value;
  }
}